import ProfileAvatar from './ProfileAvatar.jsx';

function LogOutMark() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" className="h-4 w-4 fill-none stroke-current" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 17l5-5-5-5M15 12H3" />
      <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
    </svg>
  );
}

function ShieldMark() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" className="h-4 w-4 fill-none stroke-current" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l7 3v5.5c0 4.3-2.9 8.1-7 9.5-4.1-1.4-7-5.2-7-9.5V6l7-3Z" />
      <path d="M9.5 12.2l1.8 1.8 3.4-3.4" />
    </svg>
  );
}

/**
 * Flat account strip for the mobile pill menu. Avoids nesting AccountMenu (which
 * forces a second popup + scroll) while matching the main app's compact footer.
 */
export default function MobileAccountFooter({
  profile,
  role,
  onSignOut,
  onTwoFactor,
  signingOut = false,
  showSignOut = true,
  roleLabel: roleLabelOverride,
  t,
}) {
  const fullName = profile?.name?.trim() || profile?.email?.split('@')[0] || 'Administrator';
  const firstName = fullName.split(/\s+/)[0];
  const initials = fullName
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => { return part.charAt(0).toUpperCase(); })
    .join('') || 'A';
  const normalizedRole = role?.toUpperCase();
  const roleLabel = roleLabelOverride || (normalizedRole === 'SUPER_ADMIN'
    ? 'Super admin'
    : normalizedRole === 'OWNER' ? 'Owner' : 'Admin');

  return (
    <div className="px-2 py-2 flex flex-col gap-2">
      <div className="flex items-center gap-2.5 min-w-0">
        <ProfileAvatar
          profile={profile}
          initials={initials}
          className="h-9 w-9 text-[13px] shrink-0"
          style={{ backgroundColor: t.statBg, color: t.heading, border: `1px solid ${t.border}` }}
        />
        <div className="min-w-0 flex-1">
          <div
            className="truncate text-[14px] font-semibold leading-tight"
            style={{ color: t.heading, fontFamily: t.fonts.body }}
            title={fullName}
          >
            {firstName}
          </div>
          <span
            className="inline-flex mt-1 rounded px-2 py-0.5 text-[10px] leading-4 font-semibold uppercase"
            style={{ color: t.primaryText, backgroundColor: t.primaryBg, fontFamily: t.fonts.body }}
          >
            {roleLabel}
          </span>
        </div>
      </div>

      {onTwoFactor ? (
        <button
          type="button"
          onClick={onTwoFactor}
          className={`min-h-[36px] rounded-lg px-3 flex items-center gap-2.5 text-left text-[15px] font-semibold transition-colors focus:outline-none focus-visible:ring-2 ${t.focusRing}`}
          style={{ color: t.body, fontFamily: t.fonts.body }}
        >
          <ShieldMark />
          Two-factor authentication
        </button>
      ) : null}

      {showSignOut ? (
        <button
          type="button"
          disabled={signingOut}
          onClick={() => { onSignOut?.(); }}
          className={`min-h-[36px] rounded-lg px-3 flex items-center gap-2.5 text-left text-[15px] font-semibold transition-colors focus:outline-none focus-visible:ring-2 ${t.focusRing} ${signingOut ? 'cursor-not-allowed opacity-55' : ''}`}
          style={{ color: t.danger, fontFamily: t.fonts.body }}
        >
          <LogOutMark />
          {signingOut ? 'Signing out…' : 'Sign out'}
        </button>
      ) : null}
    </div>
  );
}
